export const IANA_TO_DISPLAY_LOCATION = {
    'Europe/London': 'London, UK',
    'Europe/Lisbon': 'Lisbon, Portugal',
    'Europe/Paris': 'Paris, FR',
    'Europe/Berlin': 'Berlin, DE',
    'America/New_York': 'New York, US',
    'America/Chicago': 'Chicago, US',
    'America/Los_Angeles': 'Los Angeles, US',
    'America/Toronto': 'Toronto, CA',
    'Asia/Kolkata': 'Mumbai, IN',
    'Asia/Singapore': 'Singapore',
    'Asia/Tokyo': 'Tokyo, JP',
    'Asia/Dubai': 'Dubai, AE',
    'Australia/Sydney': 'Sydney, AU',
};

export const COMMON_TIMEZONES = Object.keys(IANA_TO_DISPLAY_LOCATION);

let cachedAllTimezones = null;

export const getAllTimezones = () => {
    if (cachedAllTimezones) return cachedAllTimezones;
    try {
        if (typeof Intl !== 'undefined' && typeof Intl.supportedValuesOf === 'function') {
            cachedAllTimezones = Intl.supportedValuesOf('timeZone').slice().sort();
            return cachedAllTimezones;
        }
    } catch {
        // Fall back to the curated list below.
    }
    cachedAllTimezones = [...COMMON_TIMEZONES].sort();
    return cachedAllTimezones;
};

export const getBrowserTimezone = () => {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    } catch {
        return '';
    }
};

export const deriveDisplayLocationFromTimezone = timezone => {
    const tz = (timezone || '').trim();
    if (!tz) return '';
    if (IANA_TO_DISPLAY_LOCATION[tz]) return IANA_TO_DISPLAY_LOCATION[tz];
    const cityPart = tz.split('/').pop()?.replace(/_/g, ' ');
    return cityPart || '';
};

export const getEffectiveTimezone = member => {
    const tz = (member?.timezone || '').trim();
    return tz || null;
};

export const getEffectiveLocation = member => {
    const location = (member?.location || '').trim();
    if (location) return location;
    const tz = getEffectiveTimezone(member);
    if (tz) return deriveDisplayLocationFromTimezone(tz);
    return '';
};

export const formatLocalTime = timezone => {
    const tz = (timezone || '').trim();
    if (!tz) return '—';
    try {
        const now = new Date();
        const formatter = new Intl.DateTimeFormat(undefined, {
            timeZone: tz,
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
            timeZoneName: 'shortOffset',
        });
        return formatter.format(now);
    } catch {
        return '—';
    }
};

export const formatWorkstreamsLabel = workstreams => {
    const list = Array.isArray(workstreams) ? workstreams.filter(Boolean) : [];
    if (list.length === 0) return '—';
    if (list.length === 1) return list[0];
    return `${list[0]} +${list.length - 1}`;
};

export const searchMember = (member, query) => {
    const q = (query || '').trim().toLowerCase();
    if (!q) return true;
    const haystack = [
        member.full_name,
        member.email,
        member.organisation,
        member.job_title,
        member.department,
    ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();
    return haystack.includes(q);
};
